export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13534.91e4093a.jpg";